import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { DividendPaymentKey } from 'api/Trading-Accounts/Types/DividendsDto'
import { generateClassNameForReverseType } from 'helpers/transactions'
import { formatLocalDateUTC } from 'utils/date'
import { isEmpty } from 'utils/is-empty'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const dividendsColumns: GridColumn[] = [
  {
    title: 'Broker Symbol',
    field: DividendPaymentKey.brokerSymbol,
    cell: (props: GridCellProps): JSX.Element => {
      const brokerSymbol = props.dataItem?.exchangeSymbol
      if (isEmpty(brokerSymbol)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }

      return <td className={generateClassNameForReverseType(props.dataItem)}>{brokerSymbol}</td>
    },
    filter: 'text',
    width: 140,
    sortable: false,
    show: true,
    resizable: true,
  },
  {
    title: 'Company Name',
    field: DividendPaymentKey.companyName,
    cell: (props: GridCellProps): JSX.Element => {
      const companyName = props.dataItem?.companyName
      if (isEmpty(companyName)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }
      return <td className={generateClassNameForReverseType(props.dataItem)}>{companyName}</td>
    },
    filter: 'text',
    sortable: false,
    show: true,
  },
  {
    title: 'Dividend Type',
    field: 'eventSubType.name',
    cell: (props: GridCellProps): JSX.Element => {
      const dividendType = props.dataItem.eventSubType
      if (isEmpty(dividendType)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }
      return (
        <td className={generateClassNameForReverseType(props.dataItem)}>{dividendType.name}</td>
      )
    },
    filter: 'text',
    minResizableWidth: 80,
    resizable: true,
    sortable: false,
    show: true,
  },
  {
    title: 'Amount',
    field: DividendPaymentKey.amount,
    cell: (props: GridCellProps): JSX.Element => {
      const amount = props.dataItem?.amount
      if (isEmpty(amount)) {
        return <td className={generateClassNameForReverseType(props.dataItem, 'number')} />
      }
      return (
        <td className={generateClassNameForReverseType(props.dataItem, 'number')}>
          {amount.toFixed(4)}
        </td>
      )
    },
    filter: 'text',
    resizable: true,
    sortable: false,
    show: true,
  },
  {
    title: 'Currency',
    field: DividendPaymentKey.currency,
    cell: (props: GridCellProps): JSX.Element => {
      const currencyId = props.dataItem?.currency?.id
      if (isEmpty(currencyId)) {
        return <td className={generateClassNameForReverseType(props.dataItem)} />
      }

      return <td className={generateClassNameForReverseType(props.dataItem)}>{currencyId}</td>
    },
    filter: 'text',
    resizable: false,
    width: 125,
    sortable: false,
    show: true,
  },
  {
    title: 'Dividend Ex-Date',
    field: 'eventDate',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem.eventDate) {
        return <td />
      }
      return (
        <td className={generateClassNameForReverseType(props.dataItem, 'date')}>
          {formatLocalDateUTC(props.dataItem.eventDate)}
        </td>
      )
    },
    filter: 'text',
    resizable: false,
    sortable: true,
    show: true,
  },
]

export default dividendsColumns
